<div class="qa-multi-value-options card">
  <div class="card-body">
    <div class="card-title">
      <h5>{{_(KEYS.EDITOR.OPTIONS)}}</h5>
    </div>

    <div *ngFor="let field of question.elements; let position = index;">
      <div class="input-group mb-2 qa-multi-value-row">
        <button class="btn btn-success qa-input-position mr-1">
          {{position + 1}}
        </button>

        <div class="btn-group ml-1 mr-2">
          <button class="btn btn-primary" (click)="onPositionChange(position, position - 1)">
            <i class="fa fa-arrow-up"></i>
          </button>

          <button class="btn btn-primary" (click)="onPositionChange(position, position + 1)">
            <i class="fa fa-arrow-down"></i>
          </button>
        </div>

        <select class="form-control qa-custom-select mr-2 qa-multi-value-type-select"
                [ngModel]="field.format || 'text'"
                (ngModelChange)="onFieldTypeChange(field, $event)">
          <option *ngFor="let type of fieldTypes" [value]="type.value">{{_(type.labelKey)}}</option>
        </select>

        <input
          class="form-control qa-multi-value-title"
          [ngModel]="field.title && field.title[locale] ? field.title[locale] : ''"
          (ngModelChange)="onFieldLabelChange(position, $event)"
          placeholder="Label"
        />

        <input
          class="form-control qa-multi-value-width-input ml-2"
          type="number"
          min="1"
          max="100"
          placeholder="%"
          [ngModel]="field.options && field.options.widthPercent ? field.options.widthPercent : null"
          (ngModelChange)="onFieldWidthChange(position, $event)"
          ngbTooltip="{{_(KEYS.EDITOR.WIDTH_PERCENT)}}"
        />

        <button
          class="btn btn-secondary ml-2 qa-mandatory"
          [ngClass]="{'qa-btn-active': field.options && field.options.mandatory}"
          ngbTooltip="{{_(KEYS.EDITOR.MANDATORY)}}"
          (click)="onToggleFieldMandatory(field)"
        >
          <i class="fa fa-exclamation"></i>
        </button>

        <button
          class="btn btn-primary ml-2"
          [ngClass]="{'btn-secondary': !field.conditions || !field.conditions.mark, 'btn-primary': field.conditions && field.conditions.mark}"
          ngbTooltip="{{_(KEYS.EDITOR.MARK)}}"
          (click)="onToggleMark(field)"
        >
          <i class="fa fa-bookmark"></i>
        </button>

        <button class="btn btn-primary ml-2" ngbTooltip="{{_(KEYS.EDITOR.SCORING)}}" (click)="onScoringModal(position)">
          <i class="fa fa-sort-numeric-asc"></i>
        </button>

        <button class="btn btn-primary ml-2" ngbTooltip="{{_(KEYS.EDITOR.VARIABLES)}}" (click)="onVariablesModal(position)">
          <i class="fa fa-code"></i>
        </button>

        <button class="btn btn-primary ml-2"
                ngbTooltip="{{_(KEYS.EDITOR.OPTIONS)}}"
                (click)="toggleFieldOptions(position)">
          <i class="fa fa-sliders"></i>
        </button>

        <button class="btn btn-danger ml-2" (click)="onDeleteField(position)">
          <i class="fa fa-trash"></i>
        </button>
      </div>

      <div class="qa-scoring-info ml-5 mb-2" *ngIf="getScoringInfo(field) as scoringInfo">
        <small class="text-muted">
          <i class="fa fa-sort-numeric-asc"></i>
          {{scoringInfo.variableName}}: {{scoringInfo.value}}
        </small>
      </div>

      <div class="ml-5 mb-3 qa-multi-value-field-options" *ngIf="expandedFieldOptions[position]">
        <ng-container [ngSwitch]="field.format">
          <app-qa-question-text *ngSwitchCase="'text'" [question]="field"></app-qa-question-text>
          <app-qa-question-numeric *ngSwitchCase="'numeric'" [question]="field"></app-qa-question-numeric>
          <app-qa-question-date *ngSwitchCase="'date'" [question]="field"></app-qa-question-date>
          <app-qa-question-choice *ngSwitchCase="'singleChoice'" [question]="field"></app-qa-question-choice>
        </ng-container>
      </div>
    </div>

    <div class="btn-group mt-2">
      <button class="btn btn-sm btn-success" (click)="onAddField()">
        <i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_ENTRY)}}
      </button>
    </div>

    <div class="qa-width-warning mt-2" *ngIf="getWidthWarning() as warning">
      <i class="fa fa-exclamation-triangle"></i> {{warning}}
    </div>
  </div>
</div>

<div class="qa-multi-value-preview card mt-3" *ngIf="question.elements && question.elements.length">
  <div class="card-body">
    <div class="card-title">
      <h5>{{_(KEYS.EDITOR.PREVIEW)}}</h5>
    </div>
    <div style="overflow-x: auto;">
      <table class="table">
        <thead>
        <tr>
          <ng-container *ngFor="let field of question.elements; let pos = index;">
            <th *ngIf="field.title && field.title[locale]; else qaFieldPlaceholder" [ngStyle]="getFieldStyle(field)">{{field.title[locale] | striptags | htmldecode}}</th>
            <ng-template #qaFieldPlaceholder>
              <th class="qa-color-gray" [ngStyle]="getFieldStyle(field)">{{_(KEYS.EDITOR.ADD_ENTRY)}} {{pos + 1}}</th>
            </ng-template>
          </ng-container>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td *ngFor="let field of question.elements;" [ngStyle]="getFieldStyle(field)">
            <ng-container [ngSwitch]="field.format">
              <input *ngSwitchCase="'numeric'" type="number" class="form-control" [placeholder]="getFieldTypeLabel(field)" disabled />
              <input *ngSwitchCase="'date'" type="text" class="form-control" [placeholder]="getFieldTypeLabel(field)" disabled />
              <select *ngSwitchCase="'singleChoice'" class="form-control" disabled>
                <option value="" selected>{{getFieldTypeLabel(field)}}</option>
                <option *ngFor="let option of field.elements" [value]="option.pathHash">
                  {{option.title && option.title[locale] ? option.title[locale] : ''}}
                </option>
              </select>
              <input *ngSwitchDefault type="text" class="form-control" [placeholder]="getFieldTypeLabel(field)" disabled />
            </ng-container>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
